import { deleteExam } from '../persistence/importExam';
import type { Store } from '../persistence/port';
import { listExams } from '../persistence/readExam';
import { archiviereExamDateien, archiviereStationsmaterial } from '../platform/archive';
import { ladeBeispielpruefungen } from './zugang';

/**
 * Relays Gerätebefehle ausser `SET_SETTINGS` — `WIPE_DATA` und `INSTALL_DEMO` (Relay `main`
 * 6abb06f, 2026-10-01). Abgeholt, quittiert und gegen Doppelzustellung geschützt werden sie in
 * `geraeteEinstellungen.ts::gleicheEinstellungenAb`, zusammen mit `SET_SETTINGS`. Die
 * Aufsichtsbefehle `MESSAGE` und `TIME_ADD` stehen in `aufsicht.ts`.
 */

export const WIPE_DATA = 'WIPE_DATA';
export const INSTALL_DEMO = 'INSTALL_DEMO';

/**
 * Prüfungen vom Gerät löschen — `examID` eine, ohne `examID` alle.
 *
 * Derselbe Weg wie der Löschdialog (`features/sheets/DeleteExamDialog.tsx`): erst die Dateien
 * ins Archiv, dann die Zeilen. Die Aufnahmen verschwinden also erst nach
 * `deleted_files_retention_days`.
 *
 * ⚠️ **Ohne Rückfrage, auch bei nicht Übertragenem** (Entscheidung des Nutzers, 2026-10-01):
 * Fehler zu vermeiden ist Aufgabe des Servers. Der Dialog vor Ort warnt; ein Fernbefehl hat
 * niemanden, den er fragen könnte.
 *
 * Gibt die Kennungen zurück, die gelöscht wurden.
 */
export async function loescheDaten(
  store: Store,
  examID: string | undefined,
  log: (text: string) => Promise<void>,
): Promise<string[]> {
  const vorhanden = (await listExams(store)).map((e) => e.id);
  const ziele = examID === undefined ? vorhanden : vorhanden.filter((id) => id === examID);
  if (examID !== undefined && ziele.length === 0) {
    await log('Relay: WIPE_DATA für ' + examID + ' — die Prüfung liegt nicht auf dem Gerät.');
  }
  for (const id of ziele) {
    await archiviereExamDateien(id, log);
    await archiviereStationsmaterial(id, log);
    await deleteExam(store, id);
  }
  return ziele;
}

/**
 * Die Beispielprüfungen einlesen — was bisher nur der Schalter `demo_install` in den
 * iPad-Einstellungen auslöste (`demoSchalter.ts`).
 *
 * Sofort, auch während einer Prüfung (Entscheidung des Nutzers, 2026-10-01): betroffen sind nur
 * die Beispielprüfungen selbst — `importExam` ersetzt sie anhand ihrer Kennung, Bewertungen
 * **an ihnen** gehen dabei verloren, echte Prüfungen bleiben unberührt.
 */
export async function installiereDemo(store: Store): Promise<number> {
  return ladeBeispielpruefungen(store);
}
